import { TutorialHandler } from './TutorialHandler';
import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import StateObserver from 'src/StateObserver';
import * as Tutorial from 'src/replicant/tutorial';
import { TutorialEvent } from '../TutorialController';
import { TutorialServices } from '../services/TutorialServices';

export default abstract class OrdinaryTutorial implements TutorialHandler {
  // Injected.
  public services!: TutorialServices;

  protected abstract readonly step: TutorialStep;

  public abstract handleEvent<T>(
    event: TutorialEvent,
    data?: T,
  ): Promise<boolean>;

  public isTutorialComplete() {
    const { user } = StateObserver.getState();
    return Tutorial.getters.isTutorialStepComplete(user, this.step);
  }
}
